"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    statusBannerVariants: ()=>statusBannerVariants
});
const external_tailwind_variants_namespaceObject = require("tailwind-variants");
const statusBannerVariants = (0, external_tailwind_variants_namespaceObject.tv)({
    slots: {
        baseSlot: 'flex flex-row rounded-lg px-4 py-3',
        contentCtaSlot: '@min-[608px]:flex-row flex w-full flex-col justify-between',
        iconSlot: 'mr-3 flex flex-row items-center justify-center',
        headingSlot: 'text-[14px]',
        captionSlot: 'text-[14px]',
        ctaSlot: '@max-[608px]:w-full @max-[608px]:mt-1 @min-[608px]:ml-3 flex h-auto flex-row items-center justify-end gap-1',
        headingContentSlot: 'flex max-w-[720px] flex-col gap-1',
        iconContentWrapper: 'flex flex-row'
    },
    variants: {
        palette: {
            neutral: {},
            info: {},
            success: {},
            caution: {},
            error: {}
        },
        emphasis: {
            regular: {},
            medium: {},
            bold: {}
        }
    },
    compoundVariants: [
        {
            palette: 'neutral',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-neutral-1 border-neutral-4 text-neutral-13 border-1',
                iconSlot: '*:text-neutral-8'
            }
        },
        {
            palette: 'info',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-primary-1 border-primary-4 text-primary-13 border-1',
                iconSlot: '*:text-primary-8'
            }
        },
        {
            palette: 'success',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-success-1 border-success-4 text-success-13 border-1',
                iconSlot: '*:text-success-8'
            }
        },
        {
            palette: 'caution',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-caution-1 border-caution-4 text-caution-13 border-1',
                iconSlot: '*:text-caution-9'
            }
        },
        {
            palette: 'error',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-error-1 border-error-4 text-error-13 border-1',
                iconSlot: '*:text-error-8'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-neutral-2 text-neutral-13 border-neutral-2 border-1',
                iconSlot: '*:text-neutral-10'
            }
        },
        {
            palette: 'info',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-primary-3 text-primary-13 border-primary-3 border-1',
                iconSlot: '*:text-primary-8'
            }
        },
        {
            palette: 'success',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-success-3 text-success-13 border-success-3 border-1',
                iconSlot: '*:text-success-8'
            }
        },
        {
            palette: 'caution',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-caution-3 text-caution-13 border-caution-3 border-1',
                iconSlot: '*:text-caution-9'
            }
        },
        {
            palette: 'error',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-error-3 text-error-13 border-error-3 border-1',
                iconSlot: '*:text-error-8'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-neutral-10 text-neutral-1 border-neutral-10 border-1',
                iconSlot: '*:text-benefit-1'
            }
        },
        {
            palette: 'info',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-primary-9 text-primary-1 border-primary-9 border-1',
                iconSlot: '*:text-primary-1'
            }
        },
        {
            palette: 'success',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-success-9 text-success-1 border-success-9 border-1',
                iconSlot: '*:text-success-1'
            }
        },
        {
            palette: 'caution',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-caution-7 text-caution-13 border-caution-7 border-1',
                iconSlot: '*:text-caution-13'
            }
        },
        {
            palette: 'error',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-error-9 text-error-1 border-error-9 border-1',
                iconSlot: '*:text-error-1'
            }
        }
    ],
    defaultVariants: {
        emphasis: 'medium',
        palette: 'neutral'
    }
});
exports.statusBannerVariants = __webpack_exports__.statusBannerVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "statusBannerVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
